import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {metaSlice} from "../state/MetaSlice";
import {userSlice} from "../state/UserSlice";
import {AppState} from "../state/AppStore";
import ReactGA from "react-ga";

export const NotAuthorizedView = () => {
    const dispatch = useDispatch();
    const meta = useSelector((state: AppState) => state.meta);

    useEffect(() => {
        ReactGA.set({page: "/con/notAuthorized"});
        ReactGA.pageview("/con/notAuthorized");
    }, []);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${meta.settings.recaptchaKey}`;
        script.addEventListener("load", () => {
            const rapi = (window as any)["grecaptcha"];
            rapi.ready(function () {
                rapi.execute(meta.settings.recaptchaKey, {action: 'homepage'}).then(async (token: string) => {
                    if (!token) {
                        dispatch(metaSlice.actions.setError("You seem to be a robot"));
                        return;
                    }

                    // Update the auto token to a long lived session token
                    try {
                        const response = await fetch(`${meta.settings.sessionUrl}?authToken=${token}`, {
                            method: 'POST',
                            mode: 'cors',
                            cache: 'no-cache',
                        });

                        const sessionToken = await response.text();

                        window.localStorage.setItem("wsStreamingToken", sessionToken);
                        window.localStorage.setItem("wsStreamingUrl", meta.settings.socketUrl);
                        dispatch(userSlice.actions.setToken(sessionToken));
                    } catch (error) {
                        dispatch(metaSlice.actions.setError("You seem to be a robot"));
                        return;
                    }
                });
            });
        });
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, [meta.settings.recaptchaKey, meta.settings.sessionUrl, meta.settings.socketUrl, dispatch]);

    return (
        <div className="AppViews--view"/>
    );
};
